export default __webpack_public_path__ + "c71aaffcaf2ff6d9d865edfd8c08ab8b.png";